import { useCallback, useEffect, useRef } from "react"

export function useInterval(callback, delay) {
  const savedCallback = useRef()
  const intervalIdRef = useRef(null)

  const cancel = useCallback(() => {
    if (intervalIdRef.current !== null) {
      clearInterval(intervalIdRef.current)
      intervalIdRef.current = null
    }
  }, [])

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (delay === null) {
      return
    }

    const id = setInterval(() => savedCallback.current(cancel), delay)
    intervalIdRef.current = id

    return () => {
      clearInterval(id)
      intervalIdRef.current = null
    }
  }, [delay, cancel])

  return cancel
}
